var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse, _rect11, _rect12, _rect13, _ellipse2, _rect14, _rect15, _rect16, _ellipse3, _rect17, _circle, _circle2, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle3, _circle4, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfDirected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.598,
    height: 88.179,
    viewBox: "0 0 81.598 88.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#f5f5f5;}.c{fill:#fafafa;}.d{fill:url(#e);}.e,.p{fill:#fff;}.f{fill:#69f0ae;}.g{fill:url(#f);}.h{fill:url(#i);}.i{fill:url(#k);}.j,.k,.l,.m{fill:#6c63ff;}.k{opacity:0.7;}.l{opacity:0.5;}.m{opacity:0.3;}.n,.p{opacity:0.2;}.o{fill:url(#m);}.q{fill:url(#n);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.503,
    y1: 1.334,
    x2: 0.503,
    y2: 0.334,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.193,
    y1: 0.692,
    x2: 0.193,
    y2: 0.203,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.5,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.5,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.039,
    height: 7.142,
    transform: "translate(67.413 81.037)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.759,
    height: 6.882,
    transform: "translate(73.312 87.918) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.039,
    height: 7.142,
    transform: "translate(8.286 81.037)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.759,
    height: 6.882,
    transform: "translate(8.427 81.037)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 81.598,
    height: 82.019,
    rx: 14.86
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 80.614,
    height: 80.614,
    rx: 14.86,
    transform: "translate(0.562 0.421)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 54.493,
    height: 55.055,
    transform: "translate(13.553 13.412)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.117,
    height: 8.848,
    transform: "translate(55.751 32.022) rotate(-14.86)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.837,
    height: 8.568,
    transform: "translate(55.922 32.122) rotate(-14.86)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 16.667,
    height: 8.006,
    transform: "translate(56.56 32.243) rotate(-14.86)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.089,
    cy: 1.685,
    rx: 3.089,
    ry: 1.685,
    transform: "translate(62.136 33.089) rotate(-14.86)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 8.848,
    height: 18.117,
    transform: "translate(55.274 48.199) rotate(-71.04)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.837,
    height: 8.568,
    transform: "translate(58.235 40.009) rotate(18.96)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 16.667,
    height: 8.006,
    transform: "translate(58.698 40.466) rotate(18.96)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 1.685,
    cy: 3.089,
    rx: 1.685,
    ry: 3.089,
    transform: "translate(61.766 47.459) rotate(-71.04)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18.117,
    height: 8.848,
    transform: "translate(58.968 36.416)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.837,
    height: 8.568,
    transform: "translate(59.109 36.556)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 16.667,
    height: 8.006,
    transform: "translate(59.693 36.837)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.089,
    cy: 1.685,
    rx: 3.089,
    ry: 1.685,
    transform: "translate(64.867 39.084)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 53.649,
    height: 53.649,
    transform: "translate(13.974 13.974)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.112,
    cy: 10.112,
    r: 10.112,
    transform: "translate(30.687 30.687)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 9.691,
    cy: 9.691,
    r: 9.691,
    transform: "translate(31.108 31.108)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 2.95,
    height: 3.089,
    transform: "translate(33.426 60.109)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 2.95,
    height: 3.089,
    transform: "translate(37.359 60.109)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 2.95,
    height: 3.089,
    transform: "translate(41.29 60.109)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 2.95,
    height: 3.089,
    transform: "translate(45.223 60.109)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 2.809,
    height: 2.809,
    transform: "translate(33.496 60.25)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 2.809,
    height: 2.809,
    transform: "translate(37.428 60.25)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 2.809,
    height: 2.809,
    transform: "translate(41.361 60.25)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 2.809,
    height: 2.809,
    transform: "translate(45.294 60.25)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.562,
    height: 1.966,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 44.856, 34.638)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.562,
    height: 1.966,
    transform: "matrix(-0.574, 0.819, -0.819, -0.574, 46.96, 44.855)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.562,
    height: 1.966,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 36.742, 46.959)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.562,
    height: 1.966,
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 34.639, 36.743)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.562,
    height: 1.966,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 44.85, 34.622)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.562,
    height: 1.966,
    transform: "matrix(-0.574, 0.819, -0.819, -0.574, 46.955, 44.839)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.562,
    height: 1.966,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 36.739, 46.942)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 0.562,
    height: 1.966,
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 34.634, 36.726)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 6.109,
    cy: 6.109,
    r: 6.109,
    transform: "translate(34.69 34.69)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 5.759,
    cy: 5.759,
    r: 5.759,
    transform: "translate(35.041 35.041)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M552.64,381.233a5.757,5.757,0,0,1,8.622-5,5.757,5.757,0,1,0-6.857,9.143A5.739,5.739,0,0,1,552.64,381.233Z",
    transform: "translate(-516.546 -339.662)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M363.414,295.3H358.92V284.076a.437.437,0,0,1,.437-.435h3.622a.437.437,0,0,1,.437.437Z",
    transform: "translate(-347.122 -259.624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M362.956,478.587h-3.578a.458.458,0,0,1-.458-.458v-11.2h4.494v11.2a.458.458,0,0,1-.458.461Z",
    transform: "translate(-347.122 -420.864)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.638,200.8h3.451a.381.381,0,0,1,.381.381v10.855H99.26V201.185A.381.381,0,0,1,99.638,200.8Z",
    transform: "translate(-87.319 -176.644)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.23,384.1h4.21v11.107a.128.128,0,0,1-.128.128H99.359a.128.128,0,0,1-.128-.128V384.1Z",
    transform: "translate(-87.293 -337.893)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfDirected);
export default __webpack_public_path__ + "static/media/self-directed.e47bf776d5ec8c54974e509c54368a68.svg";
export { ForwardRef as ReactComponent };